<template>
    <main class="m-t-70">

    <div class="page-headline m-b-30 m-t-70 align-center">
            <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
            <h4 class="tagline page-headline__tagline" v-html="pageInfo.content"></h4>
        </div>

        <div class="container">
            <div class="row">

              <Contact-Form form-name="contact-us"></Contact-Form>

                <div class="col-md-4 col-md-offset-1 center-md col-xs-12 center-xs">
                    <div class="m-b-30">
                        <img src="~@/assets/images/budget-icon.png" class="m-b-20 responsive-image" width="75px" alt="">
                        <p class="condensed">
                            {{ getAQuoteContent.content }}
                            <router-link :to="{ name: 'pricing', params: { lang: $parent.$parent.$i18n.locale }}" class="button
                            button--link button--link--peach m-t-20">
                              <span class="button--link__text button--link--peach__text">{{ $t("global.getAQoute") }}</span>
                            </router-link>
                        </p>
                    </div>

                    <div class="m-b-30">
                        <p class="tagline">{{ $t("global.stayInTouch") }}</p>
                        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.twitter_profile != ''" v-bind:href="companyProfile.twitter_profile"><i class="fa fa-twitter fa-2x" aria-hidden="true"></i></a>
                        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.linkedin_profile != ''" v-bind:href="companyProfile.linkedin_profile"><i class="fa fa-linkedin fa-2x" aria-hidden="true"></i></a>
                        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.facebook_profile != ''" v-bind:href="companyProfile.facebook_profile"><i class="fa fa-facebook-f fa-2x" aria-hidden="true"></i></a>
                        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.youtube_profile != ''" v-bind:href="companyProfile.youtube_profile"><i class="fa fa-youtube fa-2x" aria-hidden="true"></i></a>
                        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.instagram_profile != ''" v-bind:href="companyProfile.instagram_profile"><i class="fa fa-instagram fa-2x" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-t-30 m-b-30">
            <gmap-map :center="{lat:21.324394, lng:39.959314}" :zoom="14" style="width: 100%; height: 300px">
                <gmap-marker :position="{lat:21.324394, lng:39.959314}" :clickable="true"></gmap-marker>
            </gmap-map>
        </div>


        <div class="container">
            <div class="row">
                <div class="col-md-4 col-xs-12 center-xs">
                    <span class="tag">{{ contactAboutSection.sub_title }}</span>
                    <h1 class="headline m-b-30 m-t-10">{{ contactAboutSection.title }}</h1>
                    <p>{{ contactAboutSection.content }}</p>

                    <router-link :to="{ name: 'about', params: { lang: $parent.$parent.$i18n.locale }}" class="button button--link button--link--peach m-t-20">
                      <span class="button--link__text button--link--peach__text">
                        {{ $t("global.readAboutThis") }}
                      </span>
                    </router-link>
                </div>
                <div class="col-md-4 col-md-offset-4 col-xs-12 center-xs">
                    <span class="tag">{{ contactProjectsSection.sub_title }}</span>
                    <h1 class="headline m-b-30 m-t-10">{{ contactProjectsSection.title }}</h1>
                    <p>{{ contactProjectsSection.content }}</p>

                    <router-link :to="{ name: 'projects', params: { lang: $parent.$parent.$i18n.locale }}" class="button button--link button--link--peach m-t-20">
                      <span class="button--link__text button--link--peach__text">
                        {{ $t("global.readAboutThis") }}
                      </span>
                    </router-link>

                </div>
            </div>
        </div>
    </main>
</template>

<script>
import FetchService from "../services/FetchService";
import ContactForm from "./modules/ContactForm";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBgOjd2mnaHQAeNYHjipHIft5xF2gVVh2k"
  }
});

const fetchService = new FetchService();

export default {
  name: "Contact",
  data() {
    return {
      pageTitle: "Loading...",
      pageInfo: {},
      contactUsContent: {},
      getAQuoteContent: {},
      jobsContent: {},
      companyProfile: {},
      companyLocation: {},
      contactAboutSection: {},
      contactProjectsSection: {}
    };
  },
  components: {
    ContactForm
  },
  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [
        { itemprop: "name", content: this.pageInfo.meta_og_description },
        { itemprop: "description", content: this.pageInfo.meta_og_description },
        { name: "og:title", content: this.pageInfo.meta_og_title },
        { name: "og:description", content: this.pageInfo.meta_og_description },
        { name: "og:url", content: this.pageInfo.meta_url },
        { name: "og:site_name", content: this.pageInfo.meta_twitter_site },
        { name: "og:type", content: this.pageInfo.meta_og_type },
        { name: "og:image", content: this.pageInfo.meta_og_image_url },

        { name: "twitter:card", content: this.pageInfo.meta_twitter_card },
        { name: "twitter:site", content: this.pageInfo.meta_twitter_site },
        { name: "twitter:title", content: this.pageInfo.meta_twitter_title },
        {
          name: "twitter:description",
          content: this.pageInfo.meta_twitter_description
        },
        {
          name: "twitter:creator",
          content: this.pageInfo.meta_twitter_creator
        },
        { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
      ]
    };
  },
  created() {
    this.getPageInfo();
    this.getAll();
  },
  methods: {
    getPageInfo() {
      fetchService
        .getPageData(this.$parent.$parent.apiURL, 1)
        .then(pageData => {
          this.pageInfo = pageData.body;
          this.pageTitle = this.pageInfo.title;
        });
    },
    getAll() {
      this.$http
        .get(this.$parent.$parent.apiURL + "/Companyprofiles")
        .then(function(response) {
          this.companyProfile = response.body[0];
        });

      fetchService
        .getTextBlock(this.$parent.$parent.apiURL, "page-contact-us")
        .then(response => {
          this.contactUsContent = response.body;
        });

      fetchService
        .getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-get-quote")
        .then(response => {
          this.getAQuoteContent = response.body;
        });

      fetchService
        .getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-jobs")
        .then(response => {
          this.jobsContent = response.body;
        });

      fetchService
        .getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-about")
        .then(response => {
          this.contactAboutSection = response.body;
        });

      fetchService
        .getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-projects")
        .then(response => {
          this.contactProjectsSection = response.body;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue